import { KVariance_INVARIANT_getInstance287bcobdrsumm as KVariance_INVARIANT_getInstance } from './KVariance.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../Unit.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../Library.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../hacks.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.gf_1 = new (KTypeProjection())(null, null);
      }
      hf() {
        return this.gf_1;
      }
      if(type) {
        return new (KTypeProjection())(KVariance_INVARIANT_getInstance(), type);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var KTypeProjectionClass;
function KTypeProjection() {
  if (KTypeProjectionClass === VOID) {
    class $ {
      constructor(variance, type) {
        Companion_getInstance();
        this.gp_1 = variance;
        this.hp_1 = type;
        // Inline function 'kotlin.require' call
        if (!(this.gp_1 == null === (this.hp_1 == null))) {
          var message = this.gp_1 == null ? 'Star projection must have no type specified.' : 'The projection variance ' + this.gp_1.toString() + ' requires type to be specified.';
          throw IllegalArgumentException().n2(toString(message));
        }
      }
      toString() {
        var tmp0_subject = this.gp_1;
        var tmp;
        switch (tmp0_subject == null ? -1 : tmp0_subject.w1_1) {
          case -1:
            tmp = '*';
            break;
          case 0:
            tmp = toString_0(this.hp_1);
            break;
          case 1:
            tmp = 'in ' + toString_0(this.hp_1);
            break;
          case 2:
            tmp = 'out ' + toString_0(this.hp_1);
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        return tmp;
      }
      hashCode() {
        var result = this.gp_1 == null ? 0 : this.gp_1.hashCode();
        result = imul(result, 31) + (this.hp_1 == null ? 0 : hashCode(this.hp_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KTypeProjection()))
          return false;
        if (!equals(this.gp_1, other.gp_1))
          return false;
        if (!equals(this.hp_1, other.hp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KTypeProjection');
    KTypeProjectionClass = $;
  }
  return KTypeProjectionClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1r485kke2vtg0,
};
//endregion

//# sourceMappingURL=KTypeProjection.mjs.map
